<script>
import GenericCrud from "@forms/GenericCrud.vue";
import EquipeProjeto from "@forms/EquipeProjeto.vue";
import api from "@services/api";
import _ from "lodash";

export default {
  extends: GenericCrud,
  components: { EquipeProjeto },
  props: {
    table: {
      type: String,
      default: "Projeto"
    }
  },
  data: () => ({
    projetoTipoList: {},
    contratoList: {},
    tabelaCalculoList: {},
    expedienteTipoList: {},
    expedienteLocalList: {},
    showModalEquipeProjeto: false,
    equipesDisponiveisList: [],
    equipeList: undefined,
    equipe: {},
    clienteList: {},
    clienteId: undefined    
  }),
  created() {
    
    this.getProjetoTipo();    
    this.getTabelaCalculoList();
    this.getExpedienteTipoList();
    this.getExpedienteLocalList();
    this.getEquipeList();
    this.getClienteList()
  },
  methods: {
    get(id) {
      api.get(`crud/${this.table}/get/${id}`).then(response => {
        this.item = response.data["data"];
        this.clienteId = this.item.clienteId;        
      });
    },
    getProjetoTipo() {
      api
        .get(`crud/ProjetoTipo`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.projetoTipoList = response.data["data"]));
    },    
    getTabelaCalculoList() {
      api
        .get(`crud/TabelaCalculo`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.tabelaCalculoList = response.data["data"]));
    },
    getContrato(element) {
      return element.id == this.item.contratoId;
    },
    getExpedienteTipoList() {
      api
        .get(`crud/ExpedienteTipo`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.expedienteTipoList = response.data["data"]));
    },
    getExpedienteLocalList() {
      api
        .get(`crud/ExpedienteLocal`, {
          params: {
            sortBy: "denominacao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.expedienteLocalList = response.data["data"]));
    },
    getEquipeList() {
      api
        .get(`crud/Equipe`, {
          params: {
            sortBy: "denominacao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.equipeList = response.data["data"]));
    },
    ListEquipesDisponiveis() {
      return this.item.equipes === undefined
        ? this.equipeList
        : this.equipeList
        ? _.differenceWith(
            this.equipeList.map(c => ({
              id: c.id,
              denominacao: c.denominacao
            })),
            this.item.equipes.map(c => ({
              id: c.id,
              denominacao: c.denominacao
            })),
            _.isEqual
          )
        : [];
    },
    openModalEquipeProjeto() {
      this.$helper.openModal();
      this.equipesDisponiveisList = this.ListEquipesDisponiveis();
      this.showModalEquipeProjeto = true;
    },
    removeEquipeProjeto(index) {
      this.item.equipes.splice(index, 1);
    },
    saveModalEquipeProjeto() {
      if (!this.item.equipes) {
        this.item.equipes = [];
      }
      var index =
        this.indexEquipeProjeto != null
          ? this.indexEquipeProjeto
          : this.item.equipes.length;
      if (this.equipe) {
        this.item.equipes[index] = _.clone(
          this.equipeList.filter(p => p.id == this.equipe.id)[0]
        );
      }
      this.closeModalEquipeProjeto();
    },
    closeModalEquipeProjeto() {
      this.$helper.closeModal();
      this.showModalEquipeProjeto = false;
      this.equipe = {};
      this.equipesDisponiveisList = [];
      this.indexEquipeProjeto = null;
    },
    save() {
      // update
      if (this.item.id) {
        this.item.clienteId = this.clienteId;        
        api.put(`crud/${this.table}/update`, this.item).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.hasSuccess = true;
            this.back();
          }
        });
      }
      // insert
      else {
        this.item.clienteId = this.clienteId;        
        api.post(`crud/${this.table}/Insert`, this.item).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.hasSuccess = true;
            this.back();
          }
        });
      }
    },
     getClienteList() {
      api
        .get(`crud/Expediente/Clientes`, {
          params: {
            sortBy: "nome",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.clienteList = response.data["data"]));
    },
    confirmRemove() {
      if (this.item.id) {
        api.delete(`crud/${this.table}`,{params:{id: this.item.id}}).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.back();
          }
        });
        this.selectedId = null;
        this.showModalDelete = false;
      }
    },
  },
  watch: {
    item: function() {
      if (this.item.contratoId && !this.item.tabelaCalculoId) {
        this.item.tabelaCalculoId = this.contratoList.find(this.getContrato)[
          "tabelaCalculoId"
        ];
      }
    },
     
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <div class="row">
        <b-form-group
          class="col-md-6"
          id="input-group-1"
          label="Cliente"
          label-for="clienteId"
        >
          <b-form-select
            id="clienteId"
            v-model="clienteId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in clienteList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.nome }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          class="col-md-6"
          label="Tabela de cálculo"
          label-for="tabelaCalculoId"
        >
          <b-form-select
            id="tabelaCalculoId"
            v-model="item.tabelaCalculoId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in tabelaCalculoList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.descricao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group
          id="input-group-2"
          class="col-md-3"
          label="Tipo do projeto"
          label-for="projetoTipoId"
        >
          <b-form-select
            id="projetoTipoId"
            v-model="item.projetoTipoId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in projetoTipoList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.descricao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-3"
          id="input-group-1"
          label="Expediente padrão"
          label-for="expedienteTipoId"
        >
          <b-form-select
            id="expedienteTipoId"
            v-model="item.expedienteTipoId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in expedienteTipoList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.descricao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-3"
          id="input-group-1"
          label="Local padrão"
          label-for="expedienteLocalId"
        >
          <b-form-select
            id="expedienteLocalId"
            v-model="item.expedienteLocalId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in expedienteLocalList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.denominacao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group id="input-group-1" class="text-center mt-4 col-md-3">
          <b-form-checkbox
            v-model="item.cobrarDeslocamento"
            :disabled="!this.editForm"
            name="check-button"
            switch
          >
            Cobrar deslocamento
          </b-form-checkbox>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Descricao"
          label-for="descricao"
          class="col-md-6"
        >
          <b-form-input
            id="descricao"
            :disabled="!this.editForm"
            v-model="item.descricao"
            type="text"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Tags"
          label-for="tags"
          class="col-md-6"
        >
          <b-form-input
            id="tags"
            :disabled="!this.editForm"
            v-model="item.tags"
            type="text"
          ></b-form-input>
        </b-form-group>
      </div>

      <b-button
        class="btn btn-icon mb-2 float-right"
        v-on:click="openModalEquipeProjeto()"
        :disabled="!editForm"
        variant="primary"
        >Adicionar nova equipe</b-button
      >

      <b-form-group id="input-group-1" label="Equipes" label-for="consultor">
        <table class="table b-table table table-hover">
          <thead class="thead-primary">
            <tr>
              <th class="columnheader" scope="col">
                Equipe
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(equipe, index) in item.equipes" :key="equipe.id">
              <th scope="row">
                {{ equipe.denominacao }}
              </th>
              <td>
                <div class="float-right">
                  <b-button
                    variant="danger"
                    class="btn btn-icon ml-2"
                    v-on:click="removeEquipeProjeto(index)"
                    :disabled="!editForm"
                  >
                    <i class="fe-delete" />
                  </b-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>

    <b-modal
      v-model="showModalEquipeProjeto"
      title="Adicionar equipe"
      centered
      hide-footer
      @close="closeModalEquipeProjeto"
    >
      <EquipeProjeto
        :editable="true"
        :item="equipe"
        :itemDisponiveis="equipesDisponiveisList"
        :saveModalEquipeProjeto="saveModalEquipeProjeto"
        :closeModalEquipeProjeto="closeModalEquipeProjeto"
      />
    </b-modal>
  </div>
</template>
